import { ReactComponent as Icon } from 'assets/menuWide/verticals.svg'
import React from 'react'

export default function VerticalsIcon(props: any) {
  return (
    <Icon {...props} />
  )
}